<template>
	<div class="task">
		<headerTemplate title="学习任务"></headerTemplate>
		<van-card v-for="(item, itemKey) in taskList" :key="itemKey" :title="item.title" :thumb="item.image">
			<template #desc>
				<div v-html="item.content"></div>
			</template>
			<template #tags>
				<div style="display: flex;
				flex-direction: column;
				align-items: baseline;
				height: 56px;
				justify-content: space-between;
				padding: 5px 0;">
					<van-tag plain type="danger">困难度：{{item.difficulty||0}}</van-tag>
					<van-tag plain type="primary">学习次数：{{item.study_count||0}}</van-tag>
					<van-tag plain type="warning ">视频数:{{item.video_count||0}}</van-tag>
				</div>
			</template>
			<template #footer>
				<van-button @click="toStudy(item)" size="mini" type="info">学习</van-button>
			</template>
		</van-card>
	</div>
</template>
<script>
	import { getTask } from '../../../api/student'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'
	export default {
		name: 'Task',
		components: {
			headerTemplate
		},
		props: [],
		data() {
			return {
				taskList: []
			}
		},
		methods: {
			toStudy({ url }) {
				location.href = url
			}
		},
		created() {
			getTask().then(res => {
				if (res.code === 10000) {
					this.taskList = res.result
				}
			}).catch(error => {
				this.$router.push('Home')
			})
		}
	}
</script>

<style lang="scss" scoped>


</style>